import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UserModule} from './user/user.module';
import {ApiModule} from './api/api.module';
import {RoleModule} from './role/role.module';
import {MaintenanceModule} from './maintenance/maintenance.module';
import {BookingStatusModule} from './booking-status/booking-status.module';


@NgModule({
    declarations: [],
    imports: [
        CommonModule,
        UserModule,
        RoleModule,
        ApiModule,
        MaintenanceModule,
        BookingStatusModule
    ],
    exports: [UserModule]
})
export class AdminModule { }
